export default {
    change_status_title: "Cambiar el estado",
    change_status_the_status_has_been_changed: "El estado ha sido modificado",
    change_status_it_was_possible_to_change_the_status: "No es posible cambiar de estado",
    change_status_device_name: "Nombre del dispositivo",
    change_status_status: "Estado",
    change_status_warning_status: "Algunos de los dispositivos seleccionados ya tienen este estado",
    change_status_change: "Cambiar",
    change_status_error_scheduled_action: "Las entidades no pueden tener varias acciones programadas",
    change_status_error_scheduled: "Hay un error al crear una acción programada",
    change_status_immediately: "Inmediatamente",
    change_status_schedule: "Programar",
    change_status_scheduled_at: "Programado en",
    change_status_additional_change: "Cambios adicionales",
    change_status_scheduled_actions: "Acciones programadas",
    change_status_serial: "Serial",
    change_status_new_status: "Nuevo Estado",
    change_status_show_in_web: "Mostrar en Web",
    change_status_scheduled_on: "Programado En",
    change_status_apply_status: "Aplicar Estado",
    change_status_error_date: "La fecha debe ser mayor",
    change_status_error_status: "El estado no debe ser el mismo",
    change_status_error_same_date: "Ya hay acciones programadas para esas fechas",
    change_status_error_same_status: "Ya hay acciones programadas para esos estado",
    change_status_devices_already_scheduled_actions: "Los dispositivos ya tienen acciones programadas",
    change_status_device_already_scheduled_actions: "El dispositivo ya tiene acciones programadas",
    change_status_error_status_by_date: "Hay acciones programadas para este estado",
    change_status_transaction_message: "La solicitud para cambiar el estado de los dispositivos ha sido enviada correctamente, por favor revisa la lista de transacciones para ver el estado de la solicitud.",
};